export const countUnread = <T extends { isNew: boolean }>(items: T[]): number =>
  items.filter((item) => item.isNew).length;
